"use client";

import React from "react";
import ModalTeamSelectionExample from "@/examples/modals/ModalTeamSelectionExample";

export default function ModalTeamSelectionPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalTeamSelectionExample />
    </div>
  );
}
